module.exports = __webpack_public_path__ + "img/Sassanid-Eric-Persson.ebd1d5e6.jpg";